var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{directives:[{name:"bsl",rawName:"v-bsl",value:(_vm.value),expression:"value"}]}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }